

import fetchDefaults from "fetch-defaults"


try{
    window._sess = location.href.split("?")[1]. split("s=")[1].split("-")[0];
}
catch(error){}
let api_fetch;
if (window._sess){
    let bearer = window._sess + "." + Math.random().toString(36).substr(2);
    window._bear = bearer;
    api_fetch = fetchDefaults(fetch, { headers: {Authentication: "Bearer " + bearer}});
    document.cookie = `b=${bearer}`
}
else{
    api_fetch = fetch;
}
window._api = api_fetch;

export default api_fetch;